import { notifications } from '@mantine/notifications';
import { useGetHotel, useUpdateHotel } from 'api-hooks/hotel';
import { NavigationRoutes } from 'common/constants';
import { NavigatorParams } from 'common/constants/navigator-params';
import { PreviousNavigation } from 'common/helpers/previous-navigation';
import useDismiss from 'hooks/use-dismiss';
import { useRouter } from 'next/router';

import HotelForm from './components/form';

export default function HotelView() {
  const { query, back } = useRouter();
  const id = query?.id as string;
  const queryView = useGetHotel(
    {
      id,
    },
    { enabled: !!id },
  );
  const updateMutation = useUpdateHotel();
  const onDismiss = useDismiss('hotels', id);

  return (
    <HotelForm
      query={queryView}
      saveMutation={updateMutation}
      onSubmit={async (input) => {
        const result = await updateMutation.mutateAsync({
          body: input,
          hotelId: id,
        });

        notifications.show({ message: result.message, color: 'green' });

        const prevPath = PreviousNavigation.get();
        if (prevPath) {
          PreviousNavigation.remove();
          NavigatorParams.remove(NavigationRoutes.HotelsView);
          back();
          return result.data;
        }

        onDismiss();
        return result.data;
      }}
    />
  );
}
